var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Both cart implementations, including separate webpack runtimes or a React
// remount, must share one queue for this page. Payloads are deliberately not keys.
const getQueue = () => {
    const page = window;
    return page.__inTourCartSaveQueue || (page.__inTourCartSaveQueue = {
        active: false,
        sequence: 0,
        idleWaiters: [],
    });
};
const runTask = (queue, task) => {
    queue.active = true;
    const next = () => {
        const pending = queue.pending;
        queue.pending = undefined;
        if (pending) {
            runTask(queue, pending);
            return;
        }
        queue.active = false;
        const waiters = queue.idleWaiters;
        queue.idleWaiters = [];
        waiters.forEach(resolve => resolve());
    };
    // A failed request or callback must release the slot just like a successful one.
    void task.run().then(next, next);
};
/** Keeps one active save and replaces the waiting save with the newest one. */
export const enqueueCartSave = (task) => {
    const queue = getQueue();
    const sequence = ++queue.sequence;
    return new Promise((resolve, reject) => {
        var _a;
        const entry = {
            run: () => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    const value = yield task(() => queue.sequence === sequence);
                    resolve({ status: 'saved', value });
                }
                catch (error) {
                    reject(error);
                }
            }),
            // Replaced callers settle immediately and never receive another save's response.
            supersede: () => resolve({ status: 'superseded' }),
        };
        if (queue.active) {
            (_a = queue.pending) === null || _a === void 0 ? void 0 : _a.supersede();
            queue.pending = entry;
        }
        else {
            runTask(queue, entry);
        }
    });
};
/** Resolves after the active save and the latest waiting save have completed. */
export const whenCartSavesIdle = () => {
    const queue = getQueue();
    return queue.active
        ? new Promise(resolve => queue.idleWaiters.push(resolve))
        : Promise.resolve();
};
